import {
  computeMaxCenteredCropBox,
  isAspectRatioMatch,
  PRODUCT_CAROUSEL_ASPECT,
} from '@/components/image/fixedAspectCrop';

/** 与 useFixedAspectCropGate.ensureAspectFile 判定保持一致，便于单测 */
export function needsFixedAspectCrop({
  width,
  height,
  aspect = PRODUCT_CAROUSEL_ASPECT,
  minOutputWidth = 0,
  minOutputHeight = 0,
}) {
  const aspectOk = isAspectRatioMatch(width, height, aspect);
  const sizeOk = (!(Number(minOutputWidth) > 0) || width >= Number(minOutputWidth))
    && (!(Number(minOutputHeight) > 0) || height >= Number(minOutputHeight));
  return !(aspectOk && sizeOk);
}

export function canCropToMinEdge(width, height, aspect = PRODUCT_CAROUSEL_ASPECT, minCropEdge = 0) {
  if (!(minCropEdge > 0)) return true;
  const maxBox = computeMaxCenteredCropBox(width, height, aspect);
  return maxBox.sw >= minCropEdge && maxBox.sh >= minCropEdge;
}
